import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Constantes } from '../../../compartido/constantes/constantes';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { LoadingPage } from '../../../compartido/cargando/loading';
import { SelectItem } from 'primeng/api';
import { environment } from '../../../../environments/environment';
import { CategoriaService, ConfiguracionGeneralService } from 'npm-servicios-catering';
import { SubCategoriaService, RequerimientoCateringService, EstadoRequerimientoCateringService, AsociacionJefeDependenciaService } from 'npm-servicios-catering';
import { Categoria, RequerimientoCatering, EstadoRequerimientoCatering, RequerimientoCateringDTO } from 'npm-modelado-catering';
import { SubCategoria } from 'npm-modelado-catering';
import { SubCategoriaSeleccionada } from '../../../compartido/modelado-compartido/subCategoriasSeleccionada';
import { DatosSesionService } from '../../servicios/datos-sesion.service';
import { DatePipe } from '@angular/common';
import { Persona } from '../../../compartido/modelado-compartido/persona';

@Component({
  selector: 'app-requerimiento-crear',
  templateUrl: './requerimiento-crear.component.html',
  styleUrls: ['./requerimiento-crear.component.css']
})
export class RequerimientoCrearComponent extends LoadingPage implements OnInit {

  constantes = Constantes;
  lstCategoria: any;
  lstSubCategoria: any;
  lstEstadoRequerimiento: EstadoRequerimientoCatering[];

  requerimientoCateringEditar: RequerimientoCateringDTO;

  busy: Subscription;
  categoriaSeleccionada: Categoria;

  temp: SubCategoriaSeleccionada;

  subCategoriaSeleccionadaTemp: SubCategoriaSeleccionada[] = [];
  subCategoriaSeleccionadaTempEliminar: SubCategoriaSeleccionada[] = [];

  subCategoriaSeleccionada: SubCategoriaSeleccionada;
  lstProductosSeleccionados: SubCategoria[];

  cantidadSubcategoriasSeleccionadas: number = 0;

  lstSubCategoriasSeleccionadas: SelectItem[] = [];

  productoSeleccionadoVer: SubCategoria = {};

  valorTotalEleccion: number;
  displayDialog: boolean = false;
  seleccionados: boolean = false;
  flag: boolean = false;

  fechaEvento: Date;
  nombreEvento: string = "";
  direccionEvento: string = "";
  horaInicio: Date;
  horaFin: Date;
  observaciones: string = "";//observaciones sobre el servicio seleccionado en caso de que existiese
  direccionReferenciaEvento: string = "";
  horaServicioEnEvento: Date;
  telefonoResponsable: string;

  idEstadoElaborada: number = 0;
  idEstadoAceptada: number = 0;
  requerimientoCateringGuardar: RequerimientoCatering = {};

  fechaCreacionPlanificacion: Date;

  idRequerimientoCatering: number;
  tituloPagina: string;

  nuevoRequerimientoCatering: boolean = false;

  nombrePlanificacion: string;

  nombresPersonaContacto: string = "";
  correoPersonaContacto: string = "";
  telefonoPersonaContacto: string = "";
  identificacionBusquedaPersonaContacto: string = "";
  personaRecuperada: Persona;
  identificacionRecuperada: String;
  idPersonaContactoServicio: string = "";

  lstPersonasResultados: Persona[];

  lstPersonasResultadosDocentes: Persona[];
  selectedPersonaBusqueda: Persona;
  selectedPersona: Persona;
  mostrandoBuscarPersona: boolean;
  flagEncuentraPersona: boolean = false;
  loadingBusqueda: boolean;
  nombresPersona: string;
  textoBusquedaUnidad: string = "";

  disabledCampos: boolean = false;
  porcentajeEditable: number = 0;
  cantidadAuxiliar: number = 0;

  editadoCantidad: boolean;
  _idEstadoRequerimiento: number = 0;
  constructor(private router: Router, private categoriaService: CategoriaService, private subCategoriaService: SubCategoriaService,
    private requerimientoCateringService: RequerimientoCateringService,
    private datosSesionService: DatosSesionService, public estadoRequerimientoCateringService: EstadoRequerimientoCateringService,
    private routeParams: ActivatedRoute, public datepipe: DatePipe, private ConfiguracionGeneralService: ConfiguracionGeneralService,
    private asociacionJefeDependenciaService: AsociacionJefeDependenciaService) { super(false); }

  ngOnInit() {

    this.cargarEnviroment();
    console.log(this.datosSesionService.getUsuario());

    if (this.routeParams.snapshot.queryParams['id']) {
      this.idRequerimientoCatering = this.routeParams.snapshot.queryParams['id'];
      // this.disabledCampos= this.routeParams.snapshot.queryParams['estado'];
      if (this.routeParams.snapshot.queryParams['estado'] == "true") {
        this.disabledCampos = true;
      }

      this.tituloPagina = this._editar;
      this.buscarPorcentajeEditable();
      this.obtenerRequerimientoPorId(this.idRequerimientoCatering);
      this.nuevoRequerimientoCatering = false;

    } else {
      this.idRequerimientoCatering = -1;
      this.tituloPagina = this._nuevoJefeDependencia;
      this.nuevoRequerimientoCatering = true;
    }

    this.lstProductosSeleccionados = [];
    this.obtenerCategorias();
    this.obtenerEstadoRequerimiento();
    this.cantidadSubcategoriasSeleccionadas = 0;
    this.seleccionados = false;
    this.valorTotalEleccion = 0;
    this.nombrePlanificacion = this.datosSesionService.nombrePlanificacionActual;
    this.fechaCreacionPlanificacion = new Date(this.datosSesionService.fechaCreacionPlanificacion);
  }

  obtenerCategorias() {
    this.busy = this.categoriaService.listarCategoria().then(categorias => {
      if (categorias) {
        this.lstCategoria = categorias;
      }
    }).catch(error => {
      this.mostrarMensajeError("No se encuentra disponible el servicio de listar categorías, intente más adelante refrescando la pestaña o comuníquese con el administrador");
    });
  }

  obtenerEstadoRequerimiento() {
    this.busy = this.estadoRequerimientoCateringService.listarEstadoRequerimientoCatering().then(estadoRequerimiento => {
      if (estadoRequerimiento) {

        this.lstEstadoRequerimiento = estadoRequerimiento;
        for (var i = 0; i < this.lstEstadoRequerimiento.length; i++) {
          if (this.lstEstadoRequerimiento[i].nombre.localeCompare("ELABORADA") == 0) {
            this.idEstadoElaborada = this.lstEstadoRequerimiento[i].idEstadoRequerimientoCatering;

          }
          if (this.lstEstadoRequerimiento[i].nombre.localeCompare("ACEPTADA") == 0) {

            this.idEstadoAceptada = this.lstEstadoRequerimiento[i].idEstadoRequerimientoCatering;

          }
        }
      }
    }).catch(error => {
      this.mostrarMensajeError("No se encuentra disponible el servicio de listar estado requerimiento, intente más adelante refrescando la pestaña o comuníquese con el administrador");
    });
  }

  cargarEnviroment() {
    this.categoriaService.set_constantes(Constantes);
    this.subCategoriaService.set_constantes(Constantes);
    this.estadoRequerimientoCateringService.set_constantes(Constantes);
    this.requerimientoCateringService.set_constantes(Constantes);
    this.asociacionJefeDependenciaService.set_constantes(Constantes);
    this.ConfiguracionGeneralService.set_constantes(Constantes);
  }

  obtenerSubCategoriasPorCategoria(idCategoria) {
    this.busy = this.subCategoriaService.buscarByIdCategoria(idCategoria).then(subCategorias => {
      if (subCategorias) {
        this.lstSubCategoria = subCategorias;
      }
    }).catch(error => {
      this.mostrarMensajeError("No se encuentra disponible el servicio de listar subcategorías, intente más adelante refrescando la pestaña o comuníquese con el administrador");
    });
  }
  categoriaSelection() {
    this.obtenerSubCategoriasPorCategoria(this.categoriaSeleccionada.idCategoria);
  }



  verficaExistente(producto) {
    return new Promise(resolve => {
      if (this.lstSubCategoriasSeleccionadas.length > 0) {
        for (var i = 0; i < this.lstSubCategoriasSeleccionadas.length; i++) {

          this.temp = this.lstSubCategoriasSeleccionadas[i];
          if (producto.idSubCategoria == this.temp.idSubCategoria) {
            this.flag = true;
            resolve();
            return;
          } else {
            this.flag = false;
          }
          if (i == this.lstSubCategoriasSeleccionadas.length - 1) {
            resolve();
          }
        }
      } else {
        this.flag = false;
        resolve();
      }
    });
  }

  async selectProducto(event: Event, producto: SubCategoriaSeleccionada) {
    await this.verficaExistente(producto);

    if (!this.flag) {
      if (!this.nuevoRequerimientoCatering && (this.lstSubCategoriasSeleccionadas.length == 1)) {

        this.mostrarMensajeError("Al EDITAR UN SERVICIO DE CATERING, ÚNICAMENTE SE PUEDE SELECCIONAR UN PRODUCTO DE CATERING");
      } else {
        this.valorTotalEleccion = 0;
        this.subCategoriaSeleccionada = producto;
        this.subCategoriaSeleccionada.value = producto.nombre;
        this.subCategoriaSeleccionada.cantidad = 1;
        this.subCategoriaSeleccionada.valorTotal = this.subCategoriaSeleccionada.valorUnitario * this.subCategoriaSeleccionada.cantidad;
        this.lstSubCategoriasSeleccionadas.push(this.subCategoriaSeleccionada);
        this.subCategoriaSeleccionadaTemp.push(this.subCategoriaSeleccionada);
        for (var t = 0; t < this.subCategoriaSeleccionadaTemp.length; t++) {
          this.valorTotalEleccion = this.valorTotalEleccion + this.subCategoriaSeleccionadaTemp[t].valorTotal;
        }

        this.cantidadSubcategoriasSeleccionadas++;//el numero de categorias seleccionadas se suman
        this.seleccionados = true;//ubica que hay productos seleccionados*/
      }
    } else {

      this.valorTotalEleccion = 0;
      await this.adicionaAlProductoSeleccionado(producto);
      this.lstSubCategoriasSeleccionadas = null;
      this.lstSubCategoriasSeleccionadas = [];
      for (var t = 0; t < this.subCategoriaSeleccionadaTemp.length; t++) {
        this.lstSubCategoriasSeleccionadas.push(this.subCategoriaSeleccionadaTemp[t]);

        this.valorTotalEleccion = this.valorTotalEleccion + this.subCategoriaSeleccionadaTemp[t].valorTotal;

      }
    }
    event.preventDefault();

  }

  adicionaAlProductoSeleccionado(producto) {
    for (var t = 0; t < this.subCategoriaSeleccionadaTemp.length; t++) {
      if (this.subCategoriaSeleccionadaTemp[t].idSubCategoria == producto.idSubCategoria) {
        this.subCategoriaSeleccionadaTemp[t].cantidad = this.subCategoriaSeleccionadaTemp[t].cantidad + 1;
        this.subCategoriaSeleccionadaTemp[t].valorTotal = this.subCategoriaSeleccionadaTemp[t].valorUnitario * this.subCategoriaSeleccionadaTemp[t].cantidad;
        this.subCategoriaSeleccionadaTemp[t].valorTotal = Math.round(this.subCategoriaSeleccionadaTemp[t].valorTotal * 10) / 10;
      }
    }
  }

  cambiaCantidadAlProductoSeleccionado(producto) {
    for (var t = 0; t < this.subCategoriaSeleccionadaTemp.length; t++) {
      if (this.subCategoriaSeleccionadaTemp[t].idSubCategoria == producto.idSubCategoria) {
        this.subCategoriaSeleccionadaTemp[t].cantidad = producto.cantidad;
        this.subCategoriaSeleccionadaTemp[t].valorTotal = this.subCategoriaSeleccionadaTemp[t].valorUnitario * producto.cantidad;
        this.subCategoriaSeleccionadaTemp[t].valorTotal = Math.round(this.subCategoriaSeleccionadaTemp[t].valorTotal * 10) / 10;
        
      }
    }
  }

  verProducto(event: Event, producto: SubCategoria) {
    this.productoSeleccionadoVer = producto;
    this.displayDialog = true;
    event.preventDefault();
  }

  async cambiaCantidad(event: Event, producto: SubCategoriaSeleccionada) {
    this.valorTotalEleccion = 0;
    await this.cambiaCantidadAlProductoSeleccionado(producto);
    this.lstSubCategoriasSeleccionadas = null;
    this.lstSubCategoriasSeleccionadas = [];
    for (var t = 0; t < this.subCategoriaSeleccionadaTemp.length; t++) {
      this.lstSubCategoriasSeleccionadas.push(this.subCategoriaSeleccionadaTemp[t]);
      this.valorTotalEleccion = this.valorTotalEleccion + this.subCategoriaSeleccionadaTemp[t].valorTotal;
    }
  }

  eliminaProductoSeleccionado(producto) {
    return new Promise(resolve => {
      for (var t = 0; t < this.subCategoriaSeleccionadaTemp.length; t++) {
        if (this.subCategoriaSeleccionadaTemp[t].idSubCategoria != producto.idSubCategoria) {
          this.subCategoriaSeleccionadaTempEliminar.push(this.subCategoriaSeleccionadaTemp[t]);
        }
        if (t == this.subCategoriaSeleccionadaTemp.length - 1) {
          resolve();
        }
      }
    });
  }

  copiarTempEliminarANormal() {
    return new Promise(resolve => {
      if (this.subCategoriaSeleccionadaTempEliminar.length > 0) {
        for (var i = 0; i < this.subCategoriaSeleccionadaTempEliminar.length; i++) {
          this.subCategoriaSeleccionadaTemp.push(this.subCategoriaSeleccionadaTempEliminar[i]);
          if (i == this.subCategoriaSeleccionadaTempEliminar.length - 1) {
            resolve();
          }
        }
      } else {
        resolve();
      }
    });
  }

  async deselectProducto(event: Event, producto: SubCategoriaSeleccionada) {

    this.subCategoriaSeleccionadaTempEliminar = [];
    await this.eliminaProductoSeleccionado(producto);

    this.subCategoriaSeleccionadaTemp = [];
    await this.copiarTempEliminarANormal();

    this.valorTotalEleccion = 0;
    this.lstSubCategoriasSeleccionadas = null;
    this.lstSubCategoriasSeleccionadas = [];
    if (this.subCategoriaSeleccionadaTemp.length > 0) {
      for (var t = 0; t < this.subCategoriaSeleccionadaTemp.length; t++) {
        this.lstSubCategoriasSeleccionadas.push(this.subCategoriaSeleccionadaTemp[t]);
        this.valorTotalEleccion = this.valorTotalEleccion + this.subCategoriaSeleccionadaTemp[t].valorTotal;
      }
    } else {
      this.seleccionados = false;
    }

  }

  cargaInformacionGuardar() {
    this.requerimientoCateringGuardar = {};

    this.requerimientoCateringGuardar.estadoRequerimientoCatering = {};

    console.log("REQUERIMIENTO CATERING EDITAR");
    console.log(this.requerimientoCateringEditar);

    if (!this.nuevoRequerimientoCatering) {//si es un requerimiento en edición

      this.requerimientoCateringGuardar.idRequerimientoCatering = this.idRequerimientoCatering;
      this.requerimientoCateringGuardar.usuarioCreacion = this.requerimientoCateringEditar.usuarioCreacion;
      this.requerimientoCateringGuardar.fechaCreacion = this.requerimientoCateringEditar.fechaCreacion;
      this.requerimientoCateringGuardar.estadoRequerimientoCatering.idEstadoRequerimientoCatering = this._idEstadoRequerimiento;
      this.requerimientoCateringGuardar.editadoAceptado = this.requerimientoCateringEditar.editadoAceptado;
      this.requerimientoCateringGuardar.idUsuarioCreacion = this.requerimientoCateringEditar.idUsuarioCreacion;

    } else {

      this.requerimientoCateringGuardar.estadoRequerimientoCatering.idEstadoRequerimientoCatering = this.idEstadoElaborada;//se crreará en estado elaborada
    }


    this.requerimientoCateringGuardar.direccionEvento = this.direccionEvento;
    if (this.direccionReferenciaEvento) {
      this.requerimientoCateringGuardar.direccionReferenciaEvento = this.direccionReferenciaEvento.trim(); 
    }
    this.requerimientoCateringGuardar.nombreEvento = this.nombreEvento;
    this.requerimientoCateringGuardar.fechaEvento = this.fechaEvento;
    this.requerimientoCateringGuardar.horaInicioEvento = this.horaInicio;
    this.requerimientoCateringGuardar.horaFinEvento = this.horaFin;
    if (this.horaServicioEnEvento) {
      this.requerimientoCateringGuardar.horaServicioEnEvento = this.horaServicioEnEvento;
    }
    if (this.idPersonaContactoServicio) {
      this.requerimientoCateringGuardar.responsableRecibirServicio = parseInt(this.idPersonaContactoServicio);
    }

    if (this.telefonoPersonaContacto) {
      this.requerimientoCateringGuardar.telefonoResponsable = this.telefonoPersonaContacto
    }
    this.requerimientoCateringGuardar.estaActivo = "S";


    this.requerimientoCateringGuardar.planificacionCatering = {};
    this.requerimientoCateringGuardar.planificacionCatering.idPlanificacionCatering = this.datosSesionService.idPlanificacionActual;
    this.requerimientoCateringGuardar.disponibilidadPlanificacion = {};
    this.requerimientoCateringGuardar.disponibilidadPlanificacion.idDisponibilidadPlanificacion = this.datosSesionService.idDisponibilidadPlanificacion;
    console.log(this.datosSesionService.idDisponibilidadPlanificacion + " idPlani");

  }

  async guardarClick() {//cuando se presiona el botón guardar
    if (this.nombreEvento) {
      if (this.nombreEvento.toString().trim().length > 0) {
        if (this.fechaEvento) {
          
            if (this.fechaEvento.getMonth() == (this.datosSesionService.numeroMesPlanificacion)) {
              if ( (this.fechaEvento.getFullYear() >new Date().getFullYear())|| ( (this.fechaEvento.getFullYear() >=new Date().getFullYear())&&(this.fechaEvento.getMonth() >new Date().getMonth()) ) || ( (this.fechaEvento.getFullYear() >=new Date().getFullYear())&&(this.fechaEvento.getMonth() >=new Date().getMonth())&&(this.fechaEvento.getDate() >=new Date().getDate())) )  {
              if (this.horaInicio) {
                if (this.horaFin) {
                  if (this.horaInicio <= this.horaFin) {
                    if (this.direccionEvento) {
                      if (this.direccionEvento.toString().trim().length > 0) {
                        if (this.subCategoriaSeleccionadaTemp.length > 0) {

                          await this.cargaInformacionGuardar();
                          for (var r = 0; r < this.subCategoriaSeleccionadaTemp.length; r++) {
                            this.requerimientoCateringGuardar.subCategoria = {};
                            this.requerimientoCateringGuardar.subCategoria.idSubCategoria = this.subCategoriaSeleccionadaTemp[r].idSubCategoria;
                            this.requerimientoCateringGuardar.cantidad = this.subCategoriaSeleccionadaTemp[r].cantidad;
                            if (this.subCategoriaSeleccionadaTemp[r].observaciones!=null){
                            this.requerimientoCateringGuardar.observaciones = this.subCategoriaSeleccionadaTemp[r].observaciones.trim();}

                            if (!this.nuevoRequerimientoCatering) {
                              console.log("cuando no es nuevo requerimiento")
                              if (this.horaServicioEnEvento != null) {
                                if ((this.horaServicioEnEvento <= this.horaFin) && (this.horaServicioEnEvento >= this.horaInicio)) {
                                  this.actualizarRequerimientoCatering();
                                } else {
                                  this.mostrarMensajeError("La hora de servicio en el evento debe estar entre la hora inicio y hora fin");
                                }
                              } else {
                                this.actualizarRequerimientoCatering();
                              }


                            } else {
                              this.saveRequerimientoCatering();
                            }
                          }
                        } else {
                          this.mostrarMensajeError("Debe selecionar al menos un producto");
                        }
                      } else {
                        this.mostrarMensajeError("Debe ingresar la dirección del evento");
                        this.direccionEvento = "";
                      }

                    } else {
                      this.mostrarMensajeError("Debe ingresar la dirección del evento");
                      this.direccionEvento = "";
                    }

                  } else {
                    this.mostrarMensajeError("La hora de inicio debe ser menor que la hora fin");
                  }
                } else {
                  this.mostrarMensajeError("Debe ingresar la hora de fin del evento");
                }
              } else {
                this.mostrarMensajeError("Debe ingresar la hora de inicio del evento");
              }
            } else {              
              this.mostrarMensajeError("La fecha del evento no puede ser menor a la fecha actual");
            }
          } else {
            this.mostrarMensajeError("La fecha del evento debe ser del mes que corresponde a la planificación");
          }
        } else {
          this.mostrarMensajeError("Debe seleccionar una fecha del evento");
        }
      } else {
        this.mostrarMensajeError("Debe ingresar el nombre del evento");
        this.nombreEvento = "";
      }
    } else {
      this.mostrarMensajeError("Debe ingresar el nombre del evento");
      this.nombreEvento = "";
    }
  }

  saveRequerimientoCatering() {
    this.requerimientoCateringService.crear(this.requerimientoCateringGuardar).then(requerimientoCatering => {
      if (requerimientoCatering) {
        this.redirectListadoExito(true);
      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }

  validarDetalleEntrega(): boolean {
    let resultado = true;
    let mensajeError = this._tituloMensajeValidacionGrupal;
    if (this.requerimientoCateringGuardar && this.requerimientoCateringGuardar.direccionReferenciaEvento == null) {
      mensajeError += this._saltoLineaDetalle + "Falta registrar la dirección de referencia del evento";
      resultado = false;
    }
    if (this.requerimientoCateringGuardar && this.requerimientoCateringGuardar.direccionReferenciaEvento != null) {
      if (this.requerimientoCateringGuardar.direccionReferenciaEvento.trim().length<1){
      mensajeError += this._saltoLineaDetalle + "Falta registrar la dirección de referencia del evento, la dirección ingresada tiene solo espacios en blanco";        
      this.direccionReferenciaEvento=this.direccionReferenciaEvento.trim();
      resultado = false;
    }
    }

    if (this.requerimientoCateringGuardar && this.requerimientoCateringGuardar.horaServicioEnEvento == null) {
      mensajeError += this._saltoLineaDetalle + "Falta registrar la hora del servicio del evento";
      resultado = false;
    }

    if (this.requerimientoCateringGuardar && this.requerimientoCateringGuardar.responsableRecibirServicio == null) {
      mensajeError += this._saltoLineaDetalle + "Falta registrar el responsable de recibir el servicio";
      resultado = false;
    }

    if (this.requerimientoCateringGuardar && this.requerimientoCateringGuardar.telefonoResponsable == null) {
      mensajeError += this._saltoLineaDetalle + "Falta registrar el teléfono de la persona responsable";
      resultado = false;
    }

    if (!resultado) {
      this.mostrarMensajeError(mensajeError);
    }

    return resultado;
  }

  buscarPorcentajeEditable() {
    this.ConfiguracionGeneralService.buscarTipoConfiguracion(Constantes.TIPO_CONFIGURACION_PORCENTAJE).then(responseTipoConfig => {
      if (responseTipoConfig) {
        console.log(responseTipoConfig);
        this.porcentajeEditable = responseTipoConfig;
      }
    });
  }

  actualizarRequerimientoCatering() {

    let horaInicio = this.datepipe.transform(this.horaInicio, 'HH:mm:ss');
    let horaFin = this.datepipe.transform(this.horaFin, 'HH:mm:ss');
    let horaServicioEvento = "";

    if (this.horaServicioEnEvento) {
      horaServicioEvento = this.datepipe.transform(this.horaServicioEnEvento, 'HH:mm:ss');
    }

    if (this.requerimientoCateringGuardar.estadoRequerimientoCatering.idEstadoRequerimientoCatering == this.idEstadoElaborada) {

      this.requerimientoCateringService.actualizar(this.requerimientoCateringGuardar, horaInicio, horaFin, horaServicioEvento).then(req => {
        if (req) {
          this.redirectListadoExito(true);
        }
      }).catch(error => {
        this.mostrarMensajeError(error);
      });
    } else if (this.requerimientoCateringGuardar.estadoRequerimientoCatering.idEstadoRequerimientoCatering == this.idEstadoAceptada) {

      if (this.validarDetalleEntrega()) {

        if (this.disabledCampos) {
          if (this._validarPorcentajeEditable()) {

            this.requerimientoCateringGuardar.estadoRequerimientoCatering.idEstadoRequerimientoCatering = this.idEstadoAceptada;

            if (this.cantidadAuxiliar != this.requerimientoCateringGuardar.cantidad) {
              this.requerimientoCateringGuardar.editadoAceptado = true;
            }

            this.requerimientoCateringService.actualizar(this.requerimientoCateringGuardar, horaInicio, horaFin, horaServicioEvento).then(req => {
              if (req) {
                this.redirectListadoExito(true);
              }
            }).catch(error => {
              this.mostrarMensajeError(error);
            });
          }
        }
      }
    }
  }

  _validarPorcentajeEditable(): boolean {

    let cantidadEditable = ((this.cantidadAuxiliar * this.porcentajeEditable) / 100)
    let valorMasMenos = Math.round(cantidadEditable);
    let valorEditado = (parseInt(this.requerimientoCateringGuardar.cantidad.toString())) - this.cantidadAuxiliar;
    let resultado = true;

    if (valorEditado > 0) {
      if (valorEditado > valorMasMenos)
        resultado = false;
    } else if (valorEditado < 0) {
      valorEditado = (valorEditado) * (-1)
      if (valorEditado > valorMasMenos)
        resultado = false;
    }

    if (!resultado) {
      if (valorMasMenos != 0) {
        this.mostrarMensajeError("La cantidad de " + this.requerimientoCateringEditar.nombreSubCategoria + " puedo ser modificado con un máximo de " + (this.cantidadAuxiliar + valorMasMenos) + " y un mínimo de " + (this.cantidadAuxiliar - valorMasMenos) + " unidades. " + this._mensajeEditarValorPorcentajeParte1 + this.porcentajeEditable + "%");

      } else {
        this.mostrarMensajeError("No puede editar la cantidad del servicio");

      }

    }

    return resultado;
  }

  redirectListadoExito(exito: boolean) {
    this.datosSesionService.exitoGuardandoJefeUnidad = exito;
    if (this.datosSesionService.tipoVistaActual.localeCompare("LISTADO") == 0) {
      this.router.navigate(['/planificacion/requerimiento-listar/']);
    } else {
      if (this.datosSesionService.tipoVistaActual.localeCompare("CALENDARIO") == 0) {
        this.router.navigate(['/planificacion/requerimiento-listar-calendario/']);
      }
    }

  }

  cancelarClick() {
    if (this.datosSesionService.tipoVistaActual.localeCompare("LISTADO") == 0) {
      this.router.navigate(['/planificacion/requerimiento-listar/']);
    } else {
      if (this.datosSesionService.tipoVistaActual.localeCompare("CALENDARIO") == 0) {
        this.router.navigate(['/planificacion/requerimiento-listar-calendario/']);
      }
    }
  }

  async obtenerRequerimientoPorId(idReq) {
    this.busy = this.requerimientoCateringService.buscarRequerimientoById(idReq).then(res => {
      if (res) {
        this.requerimientoCateringEditar = res;
        console.log(this.requerimientoCateringEditar);
        this.cantidadAuxiliar = this.requerimientoCateringEditar.cantidad;
        this.idPersonaContactoServicio = this.requerimientoCateringEditar.responsableRecibirServicio;

        this.nombresPersonaContacto = this.requerimientoCateringEditar.nombreResponsableRecibirServicio;
        if (this.requerimientoCateringEditar.idPersonaResponsableRecibirServicio) {
          this.idPersonaContactoServicio = this.requerimientoCateringEditar.idPersonaResponsableRecibirServicio;
          this.buscarPersonaPorId();
        }

        this.nombresPersona = this.requerimientoCateringEditar.nombreResponsableRecibirServicio;
        this.correoPersonaContacto = this.requerimientoCateringEditar.correoResponsableRecibirServicio;
        this.telefonoPersonaContacto = this.requerimientoCateringEditar.telefonoResponsable;
        this.editadoCantidad = this.requerimientoCateringEditar.editadoAceptado;

        this.busy = this.subCategoriaService.buscarByIdSubCategoria(this.requerimientoCateringEditar.idSubCategoria).then(r => {
          if (r) {
            this.subCategoriaSeleccionada = r;
            this.subCategoriaSeleccionada.value = this.subCategoriaSeleccionada.nombre;

            this.nombreEvento = this.requerimientoCateringEditar.nombreEvento;
            this.direccionEvento = this.requerimientoCateringEditar.direccionEvento;
            this.direccionReferenciaEvento = this.requerimientoCateringEditar.direccionReferenciaEvento;
            this.fechaEvento = new Date(this.requerimientoCateringEditar.fechaEvento + "T00:00:00");
            

            var splittedInicio = this.requerimientoCateringEditar.horaInicioEvento.toString().split(":", 3);
            this.horaInicio = new Date();
            this.horaInicio.setHours(parseInt(splittedInicio[0]));
            this.horaInicio.setMinutes(parseInt(splittedInicio[1]));
            this.horaInicio.setSeconds(parseInt(splittedInicio[2]));

            var splittedFin = this.requerimientoCateringEditar.horaFinEvento.toString().split(":", 3);
            this.horaFin = new Date();
            this.horaFin.setHours(parseInt(splittedFin[0]));
            this.horaFin.setMinutes(parseInt(splittedFin[1]));
            this.horaFin.setSeconds(parseInt(splittedFin[2]));


            if (this.requerimientoCateringEditar.horaServicioEnEvento) {
              var splittedFin = this.requerimientoCateringEditar.horaServicioEnEvento.toString().split(":", 3);
              this.horaServicioEnEvento = new Date();
              this.horaServicioEnEvento.setHours(parseInt(splittedFin[0]));
              this.horaServicioEnEvento.setMinutes(parseInt(splittedFin[1]));
              this.horaServicioEnEvento.setSeconds(parseInt(splittedFin[2]));
            }

            this.valorTotalEleccion = 0;
            this.subCategoriaSeleccionada.cantidad = this.requerimientoCateringEditar.cantidad;
            this.subCategoriaSeleccionada.observaciones = this.requerimientoCateringEditar.observaciones;
            this.subCategoriaSeleccionada.valorTotal = this.subCategoriaSeleccionada.valorUnitario * this.subCategoriaSeleccionada.cantidad;
            this.lstSubCategoriasSeleccionadas.push(this.subCategoriaSeleccionada);
            this.subCategoriaSeleccionadaTemp.push(this.subCategoriaSeleccionada);
            for (var t = 0; t < this.subCategoriaSeleccionadaTemp.length; t++) {
              this.valorTotalEleccion = this.valorTotalEleccion + this.subCategoriaSeleccionadaTemp[t].valorTotal;
            }

            this.cantidadSubcategoriasSeleccionadas++;//el numero de categorias seleccionadas se suman
            this.seleccionados = true;//ubica que hay productos seleccionados*/
            this._idEstadoRequerimiento = this.requerimientoCateringEditar.idEstadoRequerimiento;

          }
        }).catch(error => {
          this.mostrarMensajeError(error);
        });



      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }
  cerrarDialogoVerProducto() {
    this.displayDialog = false;
  }


  buscarPersonaPorIdentificacion() {

    if (this.identificacionBusquedaPersonaContacto) {
      const urlPersona = environment.URL_PERSONA;
      this.busy = this.asociacionJefeDependenciaService.buscarPorId(urlPersona, this.identificacionBusquedaPersonaContacto).then(persona => {
        if (persona) {

          this.personaRecuperada = persona;
          if (this.personaRecuperada.correoInstitucional) {
            this.telefonoPersonaContacto = "";
            this.idPersonaContactoServicio = this.personaRecuperada.idPersona;
            this.correoPersonaContacto = this.personaRecuperada.correoInstitucional;

            this.nombresPersonaContacto = "";
            if (this.personaRecuperada.nombrePrimero.length > 2) {
              this.nombresPersonaContacto = this.nombresPersonaContacto + this.personaRecuperada.nombrePrimero;
            }
            if (this.personaRecuperada.nombreSegundo.length > 2) {
              this.nombresPersonaContacto = this.nombresPersonaContacto + " " + this.personaRecuperada.nombreSegundo;
            }
            if (this.personaRecuperada.apellidoPrimero.length > 2) {
              this.nombresPersonaContacto = this.nombresPersonaContacto + " " + this.personaRecuperada.apellidoPrimero;
            }
            if (this.personaRecuperada.apellidoSegundo.length > 2) {
              this.nombresPersonaContacto = this.nombresPersonaContacto + " " + this.personaRecuperada.apellidoSegundo;
            }
            this.identificacionRecuperada = this.personaRecuperada.identificacion;
            this.mostrarMensajeInfo("Datos recuperados satisfactoriamente");
          } else {
            var nombresPersona = "";
            if (this.personaRecuperada.nombrePrimero.length > 2) {
              nombresPersona = nombresPersona + this.personaRecuperada.nombrePrimero;
            }
            if (this.personaRecuperada.nombreSegundo.length > 2) {
              nombresPersona = nombresPersona + " " + this.personaRecuperada.nombreSegundo;
            }
            if (this.personaRecuperada.apellidoPrimero.length > 2) {
              nombresPersona = nombresPersona + " " + this.personaRecuperada.apellidoPrimero;
            }
            if (this.personaRecuperada.apellidoSegundo.length > 2) {
              nombresPersona = nombresPersona + " " + this.personaRecuperada.apellidoSegundo;
            }
            this.mostrarMensajeInfo("La identificación ingresada perteneciente a: " + nombresPersona + " no tiene asociado un correo, por lo cual no puede ser ingresada, por favor comuníquese con la Dirección de Tecnologías para que le sea asignado un correo.");
          }
        } else {

          this.mostrarMensajeInfo("No se encuentra una persona con la identificación ingresada");
          this.nombresPersonaContacto = "";
          this.correoPersonaContacto = "";
        }
      }).catch(error => {
        this.mostrarMensajeError(error);
      });
    }
  }

  updateUrl(event) {
    for (var i = 0; i < this.lstSubCategoria.length; i++) {
      if (event == this.lstSubCategoria[i].idSubCategoria) {
        this.lstSubCategoria[i].pathFoto = "";
        return;
      }
    }

  }

  construirNombre(personaRecuperada) {
    if (personaRecuperada.apellidoPrimero != null) {
      if (personaRecuperada.apellidoPrimero.length > 0) {
        this.nombresPersona = this.nombresPersona + " " + personaRecuperada.apellidoPrimero;
      }
    }
    if (personaRecuperada.apellidoSegundo != null) {
      if (personaRecuperada.apellidoSegundo.length > 0) {
        this.nombresPersona = this.nombresPersona + " " + personaRecuperada.apellidoSegundo;
      }
    }
    if (personaRecuperada.nombrePrimero != null) {
      if (personaRecuperada.nombrePrimero.length > 0) {
        this.nombresPersona = this.nombresPersona + " " + personaRecuperada.nombrePrimero;
      }
    }
    if (personaRecuperada.nombreSegundo != null) {
      if (personaRecuperada.nombreSegundo.length > 0) {
        this.nombresPersona = this.nombresPersona + " " + personaRecuperada.nombreSegundo;
      }
    }
  }

  clickBuscarPersonaClaseCriterio() {
    if (this.textoBusquedaUnidad.trim().length > 0) {
      const urlPersona = environment.URL_PERSONA;
      this.lstPersonasResultados = undefined;
      let textoBusquedaUnidadtmp = this.textoBusquedaUnidad;

      if (!Constantes.caracteresRegex.test(textoBusquedaUnidadtmp)) {
        this.mostrarMensajeError(this._nosePermitenCaracteresEspeciales);
        return;
      } else {
        this.busy = this.asociacionJefeDependenciaService.buscarPersonaClaseCriterio(urlPersona, "ADMINISTRATIVO", this.textoBusquedaUnidad).then(responseBusqueda => {
          this.mensaje = [];
          this.lstPersonasResultados = responseBusqueda;

          this.busy = this.asociacionJefeDependenciaService.buscarPersonaClaseCriterio(urlPersona, "DOCENTE", this.textoBusquedaUnidad).then(responseBusqueda => {
            this.lstPersonasResultadosDocentes = responseBusqueda;
            this.lstPersonasResultadosDocentes.forEach(async docente => {
              this.flagEncuentraPersona = false;
              await this.buscaPersonaIgual(docente);
              if (!this.flagEncuentraPersona) {
                this.lstPersonasResultados.push(docente);
              }
            });

            this.loadingBusqueda = false;
          }).catch(error => {
            this.loadingBusqueda = false;
            this.mostrarMensajeError(error);
          });
          this.loadingBusqueda = false;
        }).catch(error => {
          this.loadingBusqueda = false;
          this.mostrarMensajeError(error);
        });
      }
      this.loadingBusqueda = true;

    } else {
      this.mostrarMensajeError("Debe ingresar el número de cédula o los nombres de la persona a buscar");
    }
  }

  buscaPersonaIgual(docente) {
    this.lstPersonasResultados.forEach(async administrativo => {
      if (docente.identificacion == administrativo.identificacion) {
        this.flagEncuentraPersona = true;
      }
    });
  }

  async clickSeleccionarPersona() {
    if (this.selectedPersonaBusqueda.correoInstitucional != null) {

      if (this.selectedPersonaBusqueda.correoInstitucional.localeCompare("No Definido") != 0) {
        this.selectedPersona = Object.assign({}, this.selectedPersonaBusqueda);
        this.personaRecuperada = Object.assign({}, this.selectedPersonaBusqueda);
        this.mostrandoBuscarPersona = false;
        this.nombresPersona = ""
        await this.construirNombre(this.selectedPersonaBusqueda);
        this.idPersonaContactoServicio = this.selectedPersona.idPersona;
        this.mostrarMensajeInfo("Se ha seleccionado correctamente");
        this.telefonoPersonaContacto = "";

      } else {
        this.selectedPersona = Object.assign({}, this.selectedPersonaBusqueda);
        await this.construirNombre(this.selectedPersonaBusqueda);
        this.mostrarMensajeInfo("La persona seleccionada no tiene asociado un correo, por lo cual no puede ser ingresada, por favor comuníquese con la Dirección de Tecnologías para que le sea asignado un correo.");

        this.mostrandoBuscarPersona = true;
      }
    } else {
      this.selectedPersona = Object.assign({}, this.selectedPersonaBusqueda);
      await this.construirNombre(this.selectedPersonaBusqueda);
      this.mostrarMensajeInfo("La persona seleccionada no tiene asociado un correo, por lo cual no puede ser ingresada, por favor comuníquese con la Dirección de Tecnologías para que le sea asignado un correo.");
      this.mostrandoBuscarPersona = true;
    }
  }

  clickMostrarBuscarPersona() {
    this.mostrandoBuscarPersona = true;
  }

  clickOcultarBuscarPersona() {
    this.mostrandoBuscarPersona = false;
  }

  buscarPersonaPorId() {
    const urlPersona = environment.URL_PERSONA;
    this.busy = this.requerimientoCateringService.buscarPersonaPorId(urlPersona, this.idPersonaContactoServicio).then(persona => {
      if (persona) {
        this.selectedPersona = persona;
        this.personaRecuperada = persona;
      }
    }).catch(error => {
      this.mostrarMensajeError(error);
    });
  }
}
